(function () {
	'use strict';

	angular.module('mx.shell').directive('mxMainContentZone', [
		function mxMainContentZoneDirective() {
			MxMainContentZoneCtrl.$inject = ['mx.shell.EventService', 'mx.shell.SideLayout', 'mx.app.DeviceService'];

			function MxMainContentZoneCtrl(eventService, mxSideLayout, mxDeviceService) {
				const vm = this;

				vm.$onInit = function () {
					vm.sideLayout = mxSideLayout;
					vm.mxDeviceService = mxDeviceService;
				};

				return vm;
			}

			return {
				restrict: 'E',
				scope: {},
				replace: true,
				bindToController: {},
				controller: MxMainContentZoneCtrl,
				controllerAs: 'vm',
				templateUrl: 'components/mx-main-content-zone/mx-main-content-zone.html',
			};
		},
	]);
})(window);
